import React from 'react';
import clsx from 'clsx';

// To be consistent with other skeleton loaders across the app, we use some global style here
import 'common/stylesheets/components/mp-skeleton.styl';

import {SkeletonListRowSize} from './types';

export function SkeletonList({
  rowSize = SkeletonListRowSize.Medium,
  className = ``,
  numRows = 8,
  elref,
}: {
  rowSize?: SkeletonListRowSize;
  numRows?: number;
  className?: string;
  elref?: string;
}) {
  return (
    <div elref={elref} className={clsx(`mp-skeleton-wrapper`, className)}>
      {Array.from({length: numRows}).map((_, index) => (
        <div key={index} className={`mp-skeleton-${rowSize}`} />
      ))}
    </div>
  );
}
